import api from "./axios";

export default class FaqService {
  getFaqCategories = () => {
    return api.get("/api/web-api/public/get-faq-categories");
  };
  getFaq = () => {
    return api.get("/api/web-api/public/get-faq");
  };
}
